/* eslint-disable */
import $ from 'jquery';
import lazy from 'jquery-lazy';
import {
    jarallax,
    jarallaxElement,
    jarallaxVideo
} from 'jarallax';
import 'jquery-lazy';
/* eslint-enable */

export default function () {



    var getUrlParameter = function getUrlParameter(sParam) {
        var sPageURL = window.location.search.substring(1),
            sURLVariables = sPageURL.split('&'),
            sParameterName,
            i;

        for (i = 0; i < sURLVariables.length; i++) {
            sParameterName = sURLVariables[i].split('=');

            if (sParameterName[0] === sParam) {
                return sParameterName[1] === undefined ? true : decodeURIComponent(sParameterName[1]);
            }
        }
    };

    let trailID = getUrlParameter('trail');
    let categoryID = getUrlParameter('category');

    if (trailID){
        $('.filter-map.active').removeClass("active");
        $('[data-trailid="'+trailID+'"]').addClass("active");
    }
    if (categoryID){
        $('.filter-cat.active').removeClass("active");
        $('[data-categoryid="'+categoryID+'"]').addClass("active");
    }


    function sendData(url, sendData) {
        $('#trail-listings-holder').html('');
        $("#loading-image").show();
        let catID = sendData.category;
        let trailID = sendData.trail;
        $.ajax({
            type: 'GET',
            url: url,
            cache: false,
            data: sendData,
            success: function (res) {
                $("#loading-image").hide();
                $('#trail-listings-holder').html(res);
                $.event.trigger({
                    type: "ajaxLoaded"
                });
                let newUrl = url + '?category=' + catID + '&trail=' + trailID;
                console.log(sendData, url);
                window.history.pushState(sendData, "", newUrl);
                console.log(mapMarkers);
            }
        });
    }

    $('.filter-map').click(function (e) {
        e.preventDefault();
        $('.filter-map.active').removeClass("active");
        $(this).addClass("active");
        let catID = $('.filter-cat.active').data('categoryid');
        let trailID = $(this).data('trailid');
        let url = window.location.pathname;
        let dataToSend = {trail: trailID, category: catID};
        console.log(dataToSend, url);
        //return false;
        sendData(url, dataToSend);

    });

    $('.filter-cat').click(function (e) {
        e.preventDefault();
        $('.filter-cat.active').removeClass("active");
        $(this).addClass("active");
        let catID = $(this).data('categoryid');
        let trailID = $('.filter-map.active').data('trailid');
        let url = window.location.pathname;
        let dataToSend = {trail: trailID, category: catID};
        console.log(dataToSend, url);
        //return false;
        sendData(url, dataToSend);

    });



}
